import { Controller } from "@hotwired/stimulus"

// The file viewer (repairs/_file_viewer, 21.10.2026): a click on a link with data-file-viewer
// loads the file into the frame and opens the overlay; closing it leaves the page as it was.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.placeholder = this.frameTarget.innerHTML
    this.open = this.open.bind(this)
    this.forceClose = this.forceClose.bind(this)
    document.addEventListener("click", this.open)
    // Any re-render of the page while the viewer is open -- a refresh in place after an action, a reload after a
    // scan -- took Bootstrap's backdrop away and left the invisible window over the page, catching every click,
    // with "Loading …" on top (28.10.2026, Nordfließ). Before every render the viewer closes cleanly.
    document.addEventListener("turbo:before-render", this.forceClose)
    this.forceClose()
    this.element.addEventListener("hidden.bs.modal", () => this.reset())
    // An answer without the frame (the file is gone since, the session ended): show that page instead.
    this.frameTarget.addEventListener("turbo:frame-missing", (event) => {
      event.preventDefault()
      event.detail.visit(event.detail.response)
    })
  }

  disconnect() {
    document.removeEventListener("click", this.open)
    document.removeEventListener("turbo:before-render", this.forceClose)
  }

  // Closed at once, without the animation, and whatever Bootstrap left behind taken away.
  forceClose() {
    window.bootstrap?.Modal.getInstance(this.element)?.dispose()
    this.element.classList.remove("show")
    this.element.style.display = "none"
    this.element.setAttribute("aria-hidden", "true")
    this.element.removeAttribute("aria-modal")
    this.element.removeAttribute("role")
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
    if (!document.querySelector(".modal.show")) {
      document.body.classList.remove("modal-open")
      document.body.style.removeProperty("overflow")
      document.body.style.removeProperty("padding-right")
    }
    this.reset()
  }

  open(event) {
    const link = event.target.closest("a[data-file-viewer]")
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return

    event.preventDefault()
    this.reset()
    this.frameTarget.src = link.href
    window.bootstrap.Modal.getOrCreateInstance(this.element).show()
  }

  reset() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = this.placeholder
  }
}
